import { User } from 'contexts/ViewerContext'

import {
  pageView as segmentPageView,
  trackEvent as segmentTrackEvent,
  identifyUser as segmentIdentifyUser,
  group as segmentGroup,
  onReady as segmentOnReady,
} from 'utils/SegmentAnalytics'

import {
  pageView as googleAnalyticsAggregatorPageView,
  trackEvent as googleAnalyticsAggregatorTrackEvent,
  setUser as googleAnalyticsAggregatorSetUser,
} from 'utils/GoogleAnalyticsAggregator'

import { identify as cioIdentify, track as cioTrack } from 'utils/cio'
import { Peekaboo } from 'components/experiments/peekaboo/usePeekaboo'

export const pageView = (domain: string, pageName: string) => {
  if (typeof window === 'undefined') {
    return
  }

  googleAnalyticsAggregatorPageView(domain, pageName)
  segmentPageView(domain, pageName)
}

export const trackExperiments = (experiments: Peekaboo['experiments']) => {
  experiments.forEach((experiment) => {
    const experimentKey = experiment.key
    const variation = experiment.variation.key

    trackExperimentVaratiation(experimentKey, variation)
  })
}

const trackExperimentVaratiation = (experiment: string, variation: string) => {
  if (typeof window === 'undefined') {
    return
  }

  cioTrack(experiment + ' ' + variation)
  group(experiment, { variation })
}

export const trackEvent = (domain: string, customEventName: string, metadata?: any) => {
  if (typeof window === 'undefined') {
    return
  }
  segmentTrackEvent(domain, customEventName, metadata)
}

export const trackClickEvent = (domain: string, customEventName: string) => {
  if (typeof window === 'undefined') {
    return
  }

  googleAnalyticsAggregatorTrackEvent(domain, 'ClickEvent', customEventName)
  segmentTrackEvent(domain, 'ClickEvent', { eventName: customEventName })
}

export const group = (id: string, metadata: any) => {
  if (typeof window === 'undefined') {
    return
  }
  segmentGroup(id, metadata)
}

export const setUser = (domain: string, user: User) => {
  if (typeof window === 'undefined') {
    return
  }

  if (user) {
    const userId = user.userId
    const email = user.email
    googleAnalyticsAggregatorSetUser(userId)
    segmentIdentifyUser(userId, email)
    cioIdentify(user)
  }
  updateOptimize()
}

const updateOptimize = () => {
  if (typeof window === 'undefined') {
    return
  }

  segmentOnReady(() => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate.login_flow_completed' })
    }

    if (window.gtag) {
      window.gtag('event', 'optimize.callback', {
        callback: (value, name) => group(name, { variant: value }),
      })
    }
  })
}

/**
 * Nov 25 2020
 * Types unavailable for dataLayer.
 * We're probably switching a/b testing frameworks anyway
 */
declare global {
  interface Window {
    dataLayer: any[]
  }
}
